import { render, staticRenderFns } from "./WorkerJobInfo.vue?vue&type=template&id=58fda322&"
import script from "./WorkerJobInfo.vue?vue&type=script&lang=js&"
export * from "./WorkerJobInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports